/*
 * @Last Modified time: 2019-08-04 00:51:30
 * 阻止XSS攻击
 * 使用方式 <div v-html="$xss.process(modeval)"></div>
 */
import xss from 'xss'

const xssIns = new xss.FilterXSS({
    onTag: function(tag, html, options) {
    },
    onTagAttr: function(tag, name, value, isWhiteAttr) {
        if (name === 'href' || name === 'title' || name === 'src' || name === 'alt' || name === 'class' || name === 'style') {
            if (value.indexOf('javascript:') > -1 || value.indexOf('<script>') > -1) {
                return ''
            } else {
                return `${name}="${value}"`
            }
        } else if (name.startsWith('on')) { // 阻止所有以 on 开头的事件属性
            return ''
        } else {
            return ''
        }
    }
})

export default xssIns
